export default __webpack_public_path__ + "static/media/Standard44.5dbd1623.png";